<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['update:modelValue', 'update:focused']);
const { t } = useI18n();
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const statuses = [
    {
        title: t('Void'),
        value: 'Anulado'
    },
    {
        title: t('Repackaged'),
        value: 'Reempacado'
    },
    {
        title: t('Processed'),
        value: 'Procesado'
    },
    {
        title: t('Unprocessed'),
        value: 'Por procesar'
    },
    {
        title: t('Delivered'),
        value: 'Entregado'
    },
    {
        title: t('Invoiced'),
        value: 'FACTURADO'
    },
    {
        title: t('Pending Invoice'),
        value: 'PENDIENTE_FACTURAR'
    }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="statuses"
        :label="hideLabel ? '' : $t('State')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
